"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectListChooserState = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var multi_list_chooser_state_1 = require("./multi.list.chooser.state");
var SelectListChooserState = /** @class */ (function (_super) {
    tslib_1.__extends(SelectListChooserState, _super);
    function SelectListChooserState(field) {
        var _this = _super.call(this, field.schema.displayName) || this;
        _this.field = field;
        _this.formField = field.schema;
        _this.setValue([_this.field.value]);
        return _this;
    }
    Object.defineProperty(SelectListChooserState.prototype, "displayValue", {
        get: function () {
            return this.field.hasValue() ? this.field.displayValue : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectListChooserState.prototype, "groups", {
        get: function () {
            var visibleOptions = this.getVisibleOptions();
            if (visibleOptions.length === 0) {
                return [];
            }
            return [{
                    title: (0, i18n_1.Translate)(i18n_1.T.SELECT_OPTION),
                    items: visibleOptions,
                    selected: this.value != null ? this.value[0] : visibleOptions[0].key
                }];
        },
        enumerable: false,
        configurable: true
    });
    SelectListChooserState.prototype.setValue = function (value) {
        if (value == null || value.length === 0 || value[0] === core_shared_1.FormModelFieldSelectList.UNSELECTED_VALUE) {
            this._value = null;
        }
        else {
            this._value = value;
        }
    };
    SelectListChooserState.prototype.selectDefaultValue = function () {
        var visibleOptions = this.getVisibleOptions();
        if (visibleOptions.length > 0) {
            this.setValue([visibleOptions[0].key]);
            return;
        }
        this.setValue(null);
    };
    SelectListChooserState.prototype.getVisibleOptions = function () {
        var visibleOptions = [];
        for (var _i = 0, _a = this.formField.options; _i < _a.length; _i++) {
            var option = _a[_i];
            if (option.value !== core_shared_1.FormModelFieldSelectList.UNSELECTED_VALUE) {
                visibleOptions.push({ key: option.value, value: option.text, color: option.color });
            }
        }
        return visibleOptions;
    };
    tslib_1.__decorate([
        mobx_1.computed
    ], SelectListChooserState.prototype, "displayValue", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SelectListChooserState.prototype, "groups", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SelectListChooserState.prototype, "setValue", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SelectListChooserState.prototype, "selectDefaultValue", null);
    return SelectListChooserState;
}(multi_list_chooser_state_1.MultiChooserState));
exports.SelectListChooserState = SelectListChooserState;
//# sourceMappingURL=select.list.chooser.state.js.map